export function scrollPos() {
  return window.pageYOffset || document.documentElement.scrollTop;
}

export function areTransitionsSmooth() {
  return !document.documentElement.classList.contains('ccm-toolbar-visible');
}

export function isEditMode() {
  return document.documentElement.classList.contains('ccm-edit-mode');
}

export function debounce(fn, ms) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(fn.bind(null, ...args), ms);
  };
}
